module.exports = __webpack_public_path__ + "img/media-360.7f34b12a.png";